import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { type CustomWorkflowLauncher, useCustomWorkflowLauncher } from './useCustomWorkflowLauncher'
import { entityTag } from './entityTags'

export const useMeetingWorkflowLauncher = (): CustomWorkflowLauncher => {
  const accountId = useAppSelector(selectAccountId)
  const { roomId = '', sessionId = '' } = useParams()
  const context = useMemo(() => ({ room_id: roomId, session_id: sessionId }), [roomId, sessionId])

  return useCustomWorkflowLauncher({ accountId, scope: entityTag('meeting'), context })
}
